import React from 'react';
import { observer } from 'mobx-react';
import { OEToggle } from '../../global/oe-toggle/oe-toggle';
import Text from '../../global/text/text';
import { CommonPopupBodyFooterLayout } from '../../global/common-popup/common-popup-body-footer-layout';
import { AccountAdminSettingFormFooter } from '../common/account-admin-setting-form-footer';
import { AccountSubdomainFormVM } from './account-subdomain-form.viewmodel';
import {
    ACCOUNT_SUBDOMAIN_EXPLANATORY_TEXT,
    ACCOUNT_SUBDOMAIN_STATUS_TEXT,
    ACCOUNT_SUBDOMAIN_TEXT
} from './account-subdomain.text';
import { FormattedMessage } from 'react-intl';
import { WarningErrorIcon } from '../../global/icons/icons';
import AccountSubdomainInput from '../../global/account-subdomain-input/account-subdomain-input';
import { FormField } from '../../global/form/form-field/form-field';

import './account-subdomain-form.scss';

interface IAccountSubdomainFormPresentationProps {
    vm: AccountSubdomainFormVM;
}

const AccountSubdomainFormPresentation = observer(
    (props: IAccountSubdomainFormPresentationProps) => {
        const { vm } = props;
        const subdomain = vm.settingsEntity.additionalData as string;

        const getValidationError = () => {
            const error = vm.getSubdomainValidationMessage();

            if (Array.isArray(error)) {
                return (
                    <ul className='oe-form-field__list-error'>
                        {error.map((errorText, index) => (
                            <li key={index}>{errorText}</li>
                        ))}
                    </ul>
                );
            }

            return error ? <span className='oe-form-field__error'>{error}</span> : null;
        };

        return (
            <CommonPopupBodyFooterLayout
                body={
                    <div className='oe-form'>
                        <div className='oe-form__body'>
                            <div className='toggle-and-explanatory-wrapper'>
                                <div className='m-top-10px m-bottom-0px flex center'>
                                    <OEToggle
                                        isSelected={vm.settingsEntity.enabled}
                                        onClick={vm.toggleAccountSubdomainEnabled}
                                        dataTestId='toggle-registration-approval'
                                    />
                                    <FormattedMessage
                                        {...ACCOUNT_SUBDOMAIN_STATUS_TEXT}
                                        values={{
                                            suffix: vm.settingsEntity.suffix
                                        }}
                                    />
                                </div>
                                <div className='warning-wrapper'>
                                    <WarningErrorIcon />
                                    <Text {...ACCOUNT_SUBDOMAIN_EXPLANATORY_TEXT} />
                                </div>
                            </div>
                            {vm.settingsEntity.enabled &&
                                <div className='oe-form-field-wrapper'>
                                    <FormField
                                        label={vm.intl.formatMessage(ACCOUNT_SUBDOMAIN_TEXT)} >
                                        <AccountSubdomainInput
                                            value={subdomain}
                                            onChange={(e => vm.handleChangeWebsiteInput(e.target.value))}
                                            onBlur={() => vm.setFieldTouched()}
                                        />
                                        {vm.isFormChecked && getValidationError()}
                                    </FormField>
                                </div>
                            }
                        </div>
                    </div>
                }
                footer={
                    <AccountAdminSettingFormFooter
                        handleClose={vm.handleClose}
                        handleSubmit={vm.handleSubmit}
                        isDisabled={vm.saving}
                    />
                }
            />
        );
    }
);

export { AccountSubdomainFormPresentation };
